import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { OccurrenceTypeService } from '../../../core/services/occurrence/occurrence-type/occurrence-type.service'
import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'

@Component({
  selector: 'occurrences-modal-edit',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatSpinner

  ],
  templateUrl: './occurrences-modal-edit.component.html',
  styleUrl: './occurrences-modal-edit.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class OccurrencesModalEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OccurrencesModalEditComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService,
    private occurrenceTypeService: OccurrenceTypeService,
    private occurrenceService: OccurrenceService,
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading = false;

  documentMask = '';

  listTypeOccurrence: any = []
  listOccurrence: any = []

  page = 1;
  rows = 10;
  numberRows = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;

  ngOnInit(): void {
    this.createForm();
    this.fillForm()
    this.listOcccurrences()
    this.listTypeOccurrences()
  }



  createForm(): void {
    this.form = this.formBuilder.group({
      codeOs: ['', [Validators.required]],
      codeTg: [''],
      typeOccurrence: [''],
      occurrence: [''],
      date: [''],
      hour: [''],
      observation: [''],
    });
  }

  //Formatar a data que vem como string 00/00/00 para o formato que o input mat-datapciker aceita
  formatDate(dateString: any): Date | null {
    const dateParts = dateString.split('/');
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const year = parseInt(dateParts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }

  listOcccurrences() {
    this.occurrenceService.listOccurrence().subscribe({
      next: (res) => {
        this.listOccurrence = res.data
      },
    })
  }

  listTypeOccurrences() {
    this.occurrenceTypeService.listOccurrenceType().subscribe({
      next: (res) => {
        this.listTypeOccurrence = res.data
      },
    })
  }

  formatHour(time: any): string {
    if (!time) return '';
    return time.slice(0, 5)
  }


  fillForm() {
    this.form.patchValue({
      codeOs: this.data.item.ordemServicoId,
      codeTg: this.data.codigoTG,
      typeOccurrence: this.data.item.descricaoTipoOcorrencia,
      occurrence: this.data.item.descricaoOcorrencia,
      date: this.formatDate(this.data.item.dataOcorrido),
      hour: this.formatHour(this.data.item.horaOcorrido),
      observation: this.data.item.observacao
    })
  }


  closeModal() {
    this.dialogRef.close();
  }


  getListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }



  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }






  createModal() {
    return {
      nome: this.form.get('nomePassageiro')?.value,
      documento: this.form.get('numeroDoc')?.value,
      contato: this.form.get('contato')?.value,
      voo: this.form.get('voo')?.value,
      companhia: this.form.get('companhia')?.value,
      // horaPartida: this.formatTime(this.form.get('horaSaida')?.value),
      // horaChegada: this.formatTime(this.form.get('horaChegada')?.value),
      ordemServicoId: this.data.idOs
    }
  }


  getPassengersFromApi(): void {
    this.loading = true;


    this.passangerOs.listPagedPassengerOs(this.page, this.rows).subscribe({
      next: (res) => {


        this.passengers = res.data || [];
        this.numberRows = res?.data?.length || 0;
        this.loading = false;


      },
      error: () => {
        this.loading = false;
        console.error('Erro ao buscar passageiros');
      }
    });
  }







  resetForm() {
    this.form.reset();
  }
}
